function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import autoBind from 'react-autobind';
import ErrorSection from './error-section.jsx';
import Log from '../../lib/client/setup/log';
import LoginNotice from './login-notice.jsx';
import mustache from '../common/model/mustache';
import messages from '../../nls/setup/deploy/deploy.properties';
import NotificationSection from '../common/notification-section.jsx';
import notificationsSingleton from '../../lib/client/notifications-singleton';
import Phase from '../common/model/phase';
import PropTypes from 'prop-types';
import React from 'react';
import ServiceTabs from './services/service-tabs.jsx';
import ToolchainNameRG from './toolchain-name-rg.jsx';
import vaultUtil from '../../lib/client/vault-util';
import _ from 'lodash';
import constants from '../../lib/shared/constants';
import '../../scss/setup/deploy/_app-details.scss';
Object.assign = Object.assign || require('object-assign');
var WORK_THROTTLE = 750; // 750 ms - minimum interval between rounds of populate/validate

var WORK_POPULATE = "populate",
  WORK_VALIDATE = "validate";
var logger = Log.getLogger("d2bm");
var AppDetailsSection = /*#__PURE__*/function (_React$Component) {
  function AppDetailsSection(props) {
    var _this;
    _classCallCheck(this, AppDetailsSection);
    _this = _callSuper(this, AppDetailsSection, [props]);
    _this.state = _this.initialState();
    _this.clear = false;
    _this.error = null;
    autoBind(_this);
    return _this;
  }
  _inherits(AppDetailsSection, _React$Component);
  return _createClass(AppDetailsSection, [{
    key: "initialState",
    value: function initialState() {
      return {
        lastModification: undefined
        // lastModification_<something> state values also exist.
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if ((this.props.account || {}).accountGuid !== (prevProps.account || {}).accountGuid) {
        this.handleAccountChanged();
      }
    }
  }, {
    key: "handleAccountChanged",
    value: function handleAccountChanged() {
      var _this2 = this;
      this.props.tracker.validators().forEach(function (validator) {
        var capabilityId = validator.capability && validator.capability.capabilityId;
        if ([vaultUtil.KP_SERVICE_ID, vaultUtil.SM_SERVICE_ID, vaultUtil.EN_SERVICE_ID, "appconfig"].includes(capabilityId)) {
          _this2.handleParameterChange(validator.capability, {}, {
            needsRepopulateInitital: true
          });
        }
      });
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      if (error) {
        if (notificationsSingleton.scope) {
          notificationsSingleton.clear(notificationsSingleton.scope);
          notificationsSingleton.error(notificationsSingleton.scope, error);
        } else {
          this.clear = true;
          this.error = error;
        }
      } else if (notificationsSingleton.scope) {
        notificationsSingleton.clear(notificationsSingleton.scope);
      }
    }
  }, {
    key: "notificationsSingletonLoaded",
    value: function notificationsSingletonLoaded() {
      if (this.clear && this.error && notificationsSingleton.scope) {
        notificationsSingleton.clear(notificationsSingleton.scope);
        notificationsSingleton.error(notificationsSingleton.scope, this.error);
        this.clear = false;
        this.error = null;
      }
    }
  }, {
    key: "handleNameChanged",
    value: function handleNameChanged(val) {
      this.props.onToolchainNameChange(val);
      var updatedCapabilities = this.props.handleUpdateRefs();
      this.scheduleWork(WORK_VALIDATE, updatedCapabilities && updatedCapabilities.map(function (cap) {
        return {
          capability: cap,
          changeSummary: null
        };
      }));
      if (updatedCapabilities && updatedCapabilities.length) {
        this.updateLastModification(updatedCapabilities);
      }
    }
  }, {
    key: "handleWizardEvent",
    value: function handleWizardEvent(event) {
      switch (event.type) {
        case "create-service":
          if ([vaultUtil.KP_SERVICE_ID, vaultUtil.SM_SERVICE_ID, vaultUtil.HV_SERVICE_ID].includes(event.service)) {
            // A secret tool integration has been added, wait for all validators to complete
            // before firing dependent validators
            logger.debug("Secret integration has been added (".concat(event.service, "), scheduling dependent validators"));
            this.fireSecretDependentValidatorsWhenIdle = true;
          }
          break;
        case "delete-service":
          if ([vaultUtil.KP_SERVICE_ID, vaultUtil.SM_SERVICE_ID, vaultUtil.HV_SERVICE_ID].includes(event.service)) {
            // A secret tool integration has been removed, fire secret dependent validators now
            this.fireSecretDependentValidators();
          }
          break;
      }
    }
  }, {
    key: "fireSecretDependentValidators",
    value: function fireSecretDependentValidators() {
      var _this3 = this;
      // Find secret dependent validators
      var updatedCaps = [];
      var scheduledWorkItems = [];
      this.props.tracker.validators().forEach(function (validator) {
        if (_this3.props.isCapabilityHasSecretRef && _this3.props.isCapabilityHasSecretRef(validator.capability)) {
          logger.debug("Scheduling populate (on secret tool change) for secret refs in capability: '".concat(toCapabilitiesMapKey(validator.capability), "'"));
          scheduledWorkItems.push({
            capability: validator.capability,
            changeSummary: {},
            needsRepopulateInitital: true
          });
          updatedCaps.push(validator.capability);
        }
      });

      // Fire the validators
      if (scheduledWorkItems.length > 0) {
        this.scheduleWork(WORK_POPULATE, scheduledWorkItems);
      }
      this.updateLastModification(updatedCaps);
    }

    // Called when value of a parameter in capabilities model has changed
    // @param {object} changeSummary Map of changed fields, keyed by field name
  }, {
    key: "handleParameterChange",
    value: function handleParameterChange(capability, changeSummary) {
      var _this4 = this;
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        needsRepopulateInitital = _ref.needsRepopulateInitital,
        wizardStep = _ref.wizardStep;
      if (capability) {
        if ([vaultUtil.KP_SERVICE_ID, vaultUtil.SM_SERVICE_ID, vaultUtil.HV_SERVICE_ID].includes(capability.capabilityId)) {
          if (needsRepopulateInitital || changeSummary && Object.keys(changeSummary).find(function (key) {
            if (changeSummary[key].source === "user") {
              return true;
            } else if (changeSummary[key].source === "validator" && changeSummary[key].valueChanged) {
              return true;
            }
            return false;
          })) {
            // A secret tool parameter has changed, wait for all validators to complete
            // before firing dependent validators
            logger.debug("Scheduling secret dependent validators: ".concat(toCapabilitiesMapKey(capability), " - ").concat(needsRepopulateInitital));
            this.fireSecretDependentValidatorsWhenIdle = true;
          }
        }
        var capabilities = this.props.capabilities;
        Object.keys(changeSummary).forEach(function (paramName) {
          var change = changeSummary[paramName];
          var isValidatorOverrideMustache = false;
          if (change.source === 'validator') {
            var valueFromValidator = capability.parameters[paramName];
            var paramPath = "parameters." + paramName;
            if (valueFromValidator !== undefined && !mustache.parseTemplate(valueFromValidator) && capabilities.hasSimpleMustacheTemplate(capability, paramPath)) {
              var valueFromMustache = _this4.props.handleResolveRef(capability, paramPath);
              if (valueFromMustache === undefined) {
                // Where the template had:
                //   form:
                //     pipeline:
                //       parameters:
                //         registry-namespace: '{{registryNamespace}}'
                //   services:
                //     build:
                //       parameters:
                //         configuration:
                //           env:
                //             REGISTRY_NAMESPACE: '{{form.pipeline.parameters.registry-namespace}}'
                // and the validator has set the value in the form capability's registry-namespace parameter
                // to a value like "my-namespace",
                // then remove the mustache expression '{{registryNamespace}}'
                // to prevent a problem where '{{form.pipeline.parameters.registry-namespace}}'
                // was always evaluating to undefined, never to "my-namespace"
                // because the mustache.js evaluation always uses a mustache template if it exists,
                // only falling back to the property value if the mustache is absent.
                //   Note, checking !parseTemplate because on initial template load
                // value is set to like '{{apiKey}}', although really change.source wouldn't be 'validator'
                // then but just checking to avoid that out of paranoia.
                //   Note, checking hasSimpleMustacheTemplate, looking for a single part with a variable name,
                // to avoid removing the mustache ref for the git param repo_name: 'simple-toolchain-{{timestamp}}'
                isValidatorOverrideMustache = true;
              }
            }
          }
          if (change.source !== "validator" || isValidatorOverrideMustache) {
            // User edit was made to a templated field: delete the template
            capabilities.deleteTemplate(capability, "parameters." + paramName, capability.label);
            // Remove authURI and check/toggle form validity
            var changedCapabiityKey = toCapabilitiesMapKey(capability);
            _this4.props.tracker.validators().forEach(function (validator) {
              var validatorCapabilityKey = toCapabilitiesMapKey(validator.capability);
              if (validatorCapabilityKey === changedCapabiityKey) {
                delete validator.capabilityController.authorizationURI;
                validator.checkAndSetFormValidity(paramName, capability.parameters[paramName]);
              }
            });
            if (change.source !== 'validator') {
              logger.debug("Scheduling populate on user/non-validator change in capability: '".concat(changedCapabiityKey, "'"));
            } else {
              logger.debug("Scheduling populate on validatorOverrideMustache change in capability: '".concat(changedCapabiityKey, "'"));
            }
            // Queue a populate for this capability (required for pipeline case when changing region)
            // TODO this is problematic because it causes ANOTHER validate as well
            _this4.scheduleWork(WORK_POPULATE, [{
              capability: capability,
              changeSummary: changeSummary
            }]);
          }
        });
        if (needsRepopulateInitital) {
          logger.debug("Scheduling populate on needsRepopulateInitital in capability: '".concat(toCapabilitiesMapKey(capability), "'"));
          // Queue a populate for this capability - sometimes required when change account
          this.scheduleWork(WORK_POPULATE, [{
            capability: capability,
            changeSummary: changeSummary,
            needsRepopulateInitital: true
          }]);
        }
      }

      // Pass the change summary to the wizard for event handling
      wizardStep && wizardStep.handleParameterChange(capability, changeSummary, {
        callback: this.handleWizardEvent
      });

      // Determine indirectly impacted capabilities
      var updatedCapabilities = this.props.handleUpdateRefs();

      // schedule a populate for any indirectly related repo-tag validators
      // if any exist in the impacted list... otherwise just schedule
      // regular validation tasks on the impacted capabilities...
      if (updatedCapabilities && updatedCapabilities.length > 0) {
        var repoDependVTypes = ['repo-tag', 'repo-branch', 'repo-dir'];
        var repoTagCapabilitiesToPopulate = [];
        var updatedCapabilitiesToValidate = [];
        updatedCapabilities.forEach(function (updatedCapability) {
          // iterate over the impacted capabilities and, if the original change was in a git tool,
          // split out any repo-tag associated capabilities vs other capabilities...
          if (constants.gitServiceIds.includes(capability === null || capability === void 0 ? void 0 : capability.capabilityId) && updatedCapability.schema && updatedCapability.schema.properties && Object.keys(updatedCapability.schema.properties).find(function (key) {
            var vtype = updatedCapability.schema.properties[key].validator && updatedCapability.schema.properties[key].validator["v-type"];
            if (repoDependVTypes.includes(vtype)) {
              return true;
            }
            return false;
          })) {
            repoTagCapabilitiesToPopulate.push(updatedCapability);
          } else {
            updatedCapabilitiesToValidate.push(updatedCapability);
          }
        });
        if (repoTagCapabilitiesToPopulate.length > 0) {
          this.scheduleWork(WORK_POPULATE, repoTagCapabilitiesToPopulate.map(function (c) {
            logger.debug("Scheduling populate for repo-tag validator in capability: '".concat(toCapabilitiesMapKey(c), "'"));
            return {
              capability: c,
              changeSummary: {},
              needsRepopulateInitital: true
            };
          }));
        }
        if (updatedCapabilitiesToValidate.length > 0) {
          this.scheduleWork(WORK_VALIDATE, updatedCapabilitiesToValidate.map(function (c) {
            return {
              capability: c,
              changeSummary: null
            };
          }));
        }
      }
      if (Object.keys(changeSummary).length || updatedCapabilities && updatedCapabilities.length) {
        // const firstChangeKey = Object.keys(changeSummary).length? Object.keys(changeSummary)[0] : null;
        // const firstChange =  firstChangeKey? ({[firstChangeKey]: changeSummary[firstChangeKey]}) : null;
        // logger.debug("handleParameterChange calling updateLastModification."
        //     + " changeSummaryLength:" + Object.keys(changeSummary).length
        //     + " firstChange:" + JSON.stringify(firstChange)
        //     + " updatedCapabilities(mustache-refs):"+(updatedCapabilities? updatedCapabilities.length : 0)
        var impactedCapabilities = [].concat(_toConsumableArray(capability ? [capability] : []), _toConsumableArray(updatedCapabilities || []));
        this.updateLastModification(impactedCapabilities);
      }
      if (Object.keys(changeSummary).length) {
        // Something deep within the model changed - force update of virtual DOM ala m.redraw()
        // TODO: this is discouraged in React, should use setState somehow
        this.forceUpdate();
      }
    }
  }, {
    key: "updateLastModification",
    value: function updateLastModification(impactedCapabilities) {
      var _this5 = this;
      var lastModification = Date.now();
      // Note, number of validators !== number of capabilities,
      // so e.g. can have 2 pipeline service capabilities and 1 pipeline form capability,
      // If all 3 of them change, only update the lastModification_<mapKey> for the form capability that has the validator.
      // In other cases, where no form, update for the service capability,
      // or if no validator at all, then no update to lastModification_<mapKey>.
      var impactedCapabilityKeys = {};
      impactedCapabilities.forEach(function (cap) {
        var key = toCapabilitiesMapKey(cap);
        impactedCapabilityKeys[key] = true;
      });
      var newStates = {};
      this.props.tracker.validators().forEach(function (validator) {
        var validatorCapabilityKey = toCapabilitiesMapKey(validator.capability);
        if (impactedCapabilityKeys[validatorCapabilityKey]) {
          // found a validator whose capability was changed.
          // update lastModification_<mapKey> value for this validator
          var stateKey = _this5.getValidatorLastModificationStateKey(validator);
          newStates[stateKey] = lastModification;
        }
      });
      this.setState(_objectSpread({
        lastModification: lastModification
      }, newStates), function () {
        var lastModificationStr = new Date(lastModification).toISOString();
        logger.debug("updateLastModification " + lastModificationStr + " (" + lastModification + ") <- local lastModification updated.");
        Object.keys(newStates).forEach(function (stateKey) {
          logger.debug("updateLastModification " + lastModificationStr + " (" + lastModification + ") in " + stateKey + " <- local validator lastModification_ updated.");
        });
      });
    }
  }, {
    key: "getValidatorLastModificationStateKey",
    value: function getValidatorLastModificationStateKey(validator) {
      var stateKey = 'lastModification_' + toCapabilitiesMapKey(validator.capability).replace(' ', '__');
      return stateKey;
    }
  }, {
    key: "hasPendingValidator",
    value: function hasPendingValidator() {
      return this.prevWorkList || this.props.tracker.pending("populate").length > 0 || this.props.tracker.pending("validate").length > 0;
    }
  }, {
    key: "handleValidatorEvent",
    value: function handleValidatorEvent(type, event) {
      this.props.onValidatorEvent(type, event);
      if (type !== "load" && type !== "unload") {
        // Validator might've mutated the model - force update of virtual DOM ala m.redraw()
        // TODO: this is discouraged in React, should use setState somehow
        this.forceUpdate();

        // Check do we need to trigger secret dependent validators
        if (this.fireSecretDependentValidatorsWhenIdle && (event === null || event === void 0 ? void 0 : event.type) === "end" && !this.hasPendingValidator()) {
          // All validators idle and nothing queued
          logger.debug("Validators complete - Firing secret dependent validators");
          this.fireSecretDependentValidatorsWhenIdle = false;
          this.fireSecretDependentValidators();
        }
      }
    }

    // Manages a timer in order to throttle pending populate and validate requests. To avoid
    // wasted effort, we wait for no activity during `WORK_THROTTLE` ms before starting any work.
    // takes an array of objects: { capability: capability, changeSummary: changeSummary }
  }, {
    key: "scheduleWork",
    value: function scheduleWork(type, capabilities) {
      var _workList$type,
        _this6 = this;
      if (!(capabilities && capabilities.length)) {
        return;
      }

      // Remove all the previous validation messages before the next validation run
      capabilities.forEach(function (capObj) {
        var props = capObj.capability.schema && capObj.capability.schema.properties || {};
        Object.keys(props).forEach(function (key) {
          delete props[key].validationMessage;
        });
      });
      var workList = {
        populate: [],
        validate: []
      };
      (_workList$type = workList[type]).push.apply(_workList$type, _toConsumableArray(capabilities));
      if (this.timer) {
        // Cancel previous scheduled work; merge its work list with ours
        clearTimeout(this.timer);
        if (this.prevWorkList) {
          var _workList$validate, _workList$populate;
          (_workList$validate = workList.validate).push.apply(_workList$validate, _toConsumableArray(this.prevWorkList.validate));
          (_workList$populate = workList.populate).push.apply(_workList$populate, _toConsumableArray(this.prevWorkList.populate));
        }
      }
      this.prevWorkList = workList;
      this.timer = setTimeout(function () {
        _this6.prevWorkList = null;
        _this6.doWork(workList);
      }, WORK_THROTTLE);
    }
  }, {
    key: "doWork",
    value: function doWork(workList) {
      var _this7 = this;
      var toPopulate = toCapabilitiesMap(workList.populate);
      var toValidate = toCapabilitiesMap(workList.validate);

      // Do not bother validating capability that's about to populate, as another validate
      // will get scheduled after its populate returns
      Object.keys(toValidate).forEach(function (capabilityId) {
        if (toPopulate[capabilityId]) {
          delete toValidate[capabilityId];
        }
      });
      logger.info("Running scheduled work.");
      this.props.tracker.validators().forEach(function (validator) {
        var capabilityKey = toCapabilitiesMapKey(validator.capability);
        validator.account = _this7.props.account;
        if (toPopulate[capabilityKey]) {
          logger.info("populate " + capabilityKey);
          var options = undefined;
          if (toPopulate[capabilityKey].needsRepopulateInitital) {
            options = {
              needsRepopulateInitital: true
            };
          }
          validator.populate(toPopulate[capabilityKey].changeSummary, options);
        }
        if (toValidate[capabilityKey]) {
          logger.info("validate " + capabilityKey);
          validator.validate();
        }
      });
    }
  }, {
    key: "getLastModification",
    value: function getLastModification(validator) {
      if (validator) {
        // lastModification_<mapKey>
        var stateKey = this.getValidatorLastModificationStateKey(validator);
        var lastModification = this.state[stateKey];
        return lastModification;
      }
      return this.state.lastModification;
    }
  }, {
    key: "handleLinkToolchainLoaded",
    value: function handleLinkToolchainLoaded(toolchain) {
      var _this$props$capabilit;
      (_this$props$capabilit = this.props.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.getWizard()) === null || _this$props$capabilit === void 0 || _this$props$capabilit.handleLinkToolchainLoaded(toolchain, this.handleParameterChange);
    }
  }, {
    key: "renderToolchainName",
    value: function renderToolchainName() {
      var _this$props$capabilit2;
      return /*#__PURE__*/React.createElement(ToolchainNameRG, {
        account: this.props.account,
        allowedRegion: this.props.allowedRegion,
        capabilitiesList: this.props.capabilities && Object.keys(this.props.capabilities.map) || [],
        context: this.props.context,
        handleClearRG: this.props.handleClearRG,
        handleWizardWelcomeValid: this.props.handleWizardWelcomeValid,
        handleRegionChange: this.props.handleRegionChange,
        handleRGChange: this.props.handleRGChange,
        isDeployButtonEnabled: this.props.isDeployButtonEnabled,
        canCreateToolchain: this.props.canCreateToolchain,
        key: "name",
        onNameChange: this.handleNameChanged,
        phase: this.props.phase,
        region: this.props.region,
        reloadTemplate: this.props.reloadTemplate,
        resourceGroup: this.props.resourceGroup,
        setDirtyFlag: this.props.setDirtyFlag,
        setNameValidity: this.props.setNameValidity,
        showDynamicPicker: this.props.showDynamicPicker,
        showPipelineType: this.props.showPipelineType,
        tcRegions: this.props.tcRegions,
        value: this.props.toolchainName,
        linkToolchainOptions: this.context.wizardMode && ((_this$props$capabilit2 = this.props.capabilities) === null || _this$props$capabilit2 === void 0 || (_this$props$capabilit2 = _this$props$capabilit2.getWizard()) === null || _this$props$capabilit2 === void 0 ? void 0 : _this$props$capabilit2.getLinkToolchain()),
        handleLinkToolchainLoaded: this.handleLinkToolchainLoaded
      });
    }
  }, {
    key: "renderCapabilities",
    value: function renderCapabilities() {
      if (!this.context.wizardMode && this.props.getCapabilityCount() === 0) {
        // Skipping this for wizard to ensure the welcome step is always shown
        // This improves the source provider switching experience
        return null;
      }
      var cfTarget = {
        region: this.props.region,
        org: this.props.org,
        space: this.props.space
      };
      var isConfigRecommended;
      if (this.context.wizardMode) {
        isConfigRecommended = this.props.capabilities && this.props.capabilities.getWizardConfigRecommended();
      } else {
        isConfigRecommended = this.props.capabilities && this.props.capabilities.getConfigRecommended();
      }
      var capabilitiesClass = "service-tabs-container".concat(this.context.wizardMode ? " vertical-progress" : "");
      return (this.context.wizardMode || !this.context.wizardMode && this.props.allowedRegion) && /*#__PURE__*/React.createElement("div", {
        className: capabilitiesClass,
        key: "capabilities"
      }, this.context.wizardMode ? null : /*#__PURE__*/React.createElement("h2", {
        className: "integrations-label"
      }, messages.get("label.integrations")), /*#__PURE__*/React.createElement(ServiceTabs, {
        capabilities: this.props.capabilities,
        unresolved: this.props.unresolved,
        cfTarget: cfTarget,
        configRecommended: isConfigRecommended,
        expandedType: this.props.expandedServiceType,
        handleError: this.handleError,
        getLastModification: this.getLastModification,
        onParameterChange: this.handleParameterChange,
        onScheduleWork: this.scheduleWork,
        onScrolled: this.props.handleScrolled,
        onServiceClick: this.props.handleServiceClick,
        onValidatorEvent: this.handleValidatorEvent,
        onDetectSecretReference: this.props.onDetectSecretReference,
        overrideScroll: this.props.overrideScroll,
        shouldFocus: this.props.shouldFocus,
        updateFocus: this.props.updateFocus,
        userInfo: this.props.userInfo,
        account: this.props.account,
        createClicked: this.props.createClicked,
        validatorTracker: this.props.tracker,
        handleTabClick: this.props.handleTabClick,
        tabIndex: this.props.tabIndex,
        setAuthDone: this.props.setAuthDone,
        tcRegions: this.props.tcRegions,
        context: this.props.context,
        renderToolchainName: this.renderToolchainName,
        isWizardWelcomeValid: this.props.isWizardWelcomeValid,
        phase: this.props.phase,
        allowedRegion: this.props.allowedRegion,
        enableCreateButton: this.props.enableCreateButton,
        handleDeployClicked: this.props.handleDeployClicked,
        params: this.props.params,
        integrationsAuthDone: this.props.integrationsAuthDone,
        showTektonPipeline: this.props.showPipelineType,
        setDirtyFlag: this.props.setDirtyFlag,
        wizardCompletedStep: this.props.wizardCompletedStep,
        setWizardCompletedStep: this.props.setWizardCompletedStep,
        wizardGitAccept: this.props.wizardGitAccept,
        handleGitAcceptValid: this.props.handleGitAcceptValid,
        enableToolchainCreateButton: this.props.enableToolchainCreateButton,
        fsCloudDialogData: this.props.fsCloudDialogData
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var phase = this.props.phase;
      var error = this.props.error;
      return /*#__PURE__*/React.createElement("div", {
        className: "toolchain-details"
      }, function () {
        if (phase === Phase.LOADING || _this8.props.userInfo) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, _this8.context.wizardMode ? null : _this8.renderToolchainName(), /*#__PURE__*/React.createElement(NotificationSection, {
            singletonLoaded: _this8.notificationsSingletonLoaded
          }), _this8.props.capabilities && _this8.renderCapabilities());
        } else {
          // finished loading and we don't have a logged in user.
          return /*#__PURE__*/React.createElement(LoginNotice, null);
        }
      }(), error ? /*#__PURE__*/React.createElement(ErrorSection, {
        key: "error",
        onModalClose: this.props.onModalClose,
        error: error
      }) : null);
    }
  }]);
}(React.Component);
export { AppDetailsSection as default };
AppDetailsSection.contextTypes = {
  envId: PropTypes.string,
  wizardMode: PropTypes.bool
};
AppDetailsSection.propTypes = {
  isCapabilityHasSecretRef: PropTypes.func.isRequired
};
function toCapabilitiesMapKey(capability) {
  // When a githubconsolidated validator populate receives a stale response,
  // it should only schedule re-populate for this instance
  // not for all githubconsolidated instances in this setup/deploy page,
  // so key to include label, not just capabilityId of 'githubconsolidated'
  if (capability.label) {
    return "".concat(capability.capabilityId, " ").concat(capability.label);
  }
  return capability.capabilityId;
}
function toCapabilitiesMap(array) {
  var map = {};
  array.forEach(function (capObj) {
    if (capObj.changeSummary === null) {
      capObj.changeSummary = {};
    }
    var key = toCapabilitiesMapKey(capObj.capability);
    if (map[key]) {
      // Merge the queued changes together
      capObj.changeSummary = _.merge(capObj.changeSummary, map[key].changeSummary);
      capObj.needsRepopulateInitital = capObj.needsRepopulateInitital || map[key].needsRepopulateInitital;
    }
    map[key] = capObj;
  });
  return map;
}